export const FUNCTIONS = [
  {
    key: '1',
    title: 'Tworzenie dowolnej struktury e-sprawozdania',
    description:
      'Aplikacja umożliwia stworzenie e-sprawozdania finansowego we wszystkich podstawowych, a także dodatkowych strukturach wymaganych przez Ministra Finansów.',
  },
  {
    key: '2',
    title: 'Możliwość zapisu i wczytania pliku e-sprawozdania',
    description:
      'Utworzony przez aplikację plik można pobrać na dysk komputera, a następnie ponownie wczytać i kontynuować pracę z e-sprawozdaniem w innym dniu. Można również wczytać plik, który został utworzony przez inny program.',
  },
  {
    key: '3',
    title: 'Weryfikacja poprawności e-sprawozdania przed wysyłką',
    description:
      'Aplikacja jest wyposażona w narzędzie, które weryfikuje utworzony plik z odpowiednią strukturą opublikowaną na stronie Ministra Finansów.',
  },
  {
    key: '4',
    title: 'Automatyzacja obliczeń we wszystkich zestawieniach w programie',
    description:
      'Bilans, Rachunek zysków i strat oraz pozostałe zestawienia, w tym tabela służąca do wykazania różnicy pomiędzy CIT/PIT a RZiS są wyposażone w formuły obliczeniowe. Wystarczy wprowadzić tylko pozycje wyjściowe.',
  },
  {
    key: '5',
    title:
      'Obsługa sprawozdań z przepływu środków pieniężnych i zestawienia zmian w kapitale',
    description:
      'Dodatkowo, podmioty, które są do tego zobowiązane, mogą wypełnić zestawienie zmian w kapitale i/lub rachunek przepływów pieniężnych.',
  },
  {
    key: '6',
    title:
      'Podpowiedzi w każdej sekcji ułatwiające prawidłowe przygotowanie sprawozdania',
    description:
      'W aplikacji znajdują się podpowiedzi, dzięki którym można poprawnie i szybko uzupełnić e-sprawozdanie finansowe.',
  },
]
export const FUNCTIONS2 = [
  {
    key: '1',
    title: 'Jednostki inne niż banki i zakłady ubezpieczeń',
    description: `Wszystkie podmioty, które sporządzają wersję podstawową, pełną, sprawozdania finansowego, określoną w załączniku nr 1 ustawy z 29 września 1994 o rachunkowości
    * wersja sprawozdania skonsolidowanego dostępna w dodatkowym pakiecie,`,
  },

  {
    key: '2',
    title: 'Jednostki gospodarcze mikro',
    description: `Spółki, które w każdym z dwóch ostatnich lat obrotowych, nie przekroczyły co najmniej dwóch z następujących trzech wielkości:
    1.500.000 zł - w przypadku sumy aktywów bilansu na koniec roku obrotowego
    3.000.000 zł - w przypadku przychodów netto ze sprzedaży towarów i produktów za rok obrotowy
    10 osób - w przypadku średniorocznego zatrudnienia w przeliczeniu na pełne etaty;
    Oraz osoby fizyczne, których przychody netto ze sprzedaży towarów, produktów i operacji finansowych wyniosły równowartość w walucie polskiej nie mniej niż 2.000.000 euro i nie więcej niż 3.000.000 euro za poprzedni rok obrotowy.`,
  },
  {
    key: '3',
    title: 'Jednostki małe',
    description: `Spółki, które w każdym z dwóch ostatnich lat obrotowych, nie przekroczyły co najmniej dwóch z następujących trzech wielkości:
    25.500.000 zł - w przypadku sumy aktywów bilansu na koniec roku obrotowego
    51.000.000 zł - w przypadku przychodów netto ze sprzedaży towarów i produktów za rok obrotowy
    50 osób - w przypadku średniorocznego zatrudnienia w przeliczeniu na pełne etaty;
    Oraz osoby fizyczne, które stosują zasady rachunkowości na podstawie art. 2 ust. 2 ustawy o rachunkowości.`,
  },
  {
    key: '4',
    title: 'Organizacje pozarządowe',
    description: `Jednostki określone w ustawie z dnia 24 kwietnia 2003 r. o działalności pożytku publicznego i o wolontariacie, np. fundacje, stowarzyszenia.`,
  },
  {
    key: '5',
    title: 'Domy maklerskie',
    description: `Jednostki, które są zobowiązane do sporządzania sprawozdań finansowych zgodnych z rozporządzeniem Ministra Finansów z dnia 28 grudnia 2009 r. w sprawie szczególnych zasad rachunkowości domów maklerskich.
      * wersja dla domów maklerskich dostępna w dodatkowym pakiecie`,
  },
]
